import { api } from './client'

import type { components } from '@/lib/api/generated/schema'

/** Một người trong danh bạ khách mời. */
export type MeetingGuest = components['schemas']['MeetingGuest']
export type MeetingGuestRequest = components['schemas']['MeetingGuestRequest']

export interface MeetingGuestListParams {
    /** Khớp một phần tên, không phân biệt hoa thường. */
    search?: string
    page?: number
    per_page?: number
}

/**
 * Danh bạ khách mời — khách ngoài hệ thống tới làm việc với HTX.
 *
 * Tìm và thêm chỉ cần quyền tạo lịch họp; sửa và xoá cần `meeting_guests.manage`
 * vì chúng đụng tới tên hiển thị trong mọi cuộc họp cũ.
 */
export const meetingGuestApi = {
    list: (params?: MeetingGuestListParams) =>
        api.get<MeetingGuest[]>('/meeting-guests', { params }),

    create: (body: MeetingGuestRequest) =>
        api.post<MeetingGuest>('/meeting-guests', body),

    update: (id: string, body: MeetingGuestRequest) =>
        api.put<MeetingGuest>(`/meeting-guests/${id}`, body),

    remove: (id: string) => api.delete<void>(`/meeting-guests/${id}`),
}
